export default {
  commonMessage: {
    required: "This is a required field",
    maxCount: "A maximum of {max} characters is allowed",
    placeholder: {
      select: "Please select",
    },
    title: {
      minPriceRange: "Min. Price",
      maxPriceRange: "Max. Price",
    },
  },
  unit: {
    1: "sq.ft.",
    2: "acres",
    MYR: "RM",
    RM: "RM",
    HKD: "HK$",
  },
  errorPage: {
    errorCode: "Error code: {errorCode}",
    backButtonText: "Return to listings",
    notFoundPrompt:
      "The page you requested does not exist, or is currently unavailable.",
    notFoundMessage: "We can't seem to find the page you're looking for.",
    sysIssueMessage: "Some internal error happened, we will fixed it soon",
  },
  deleteListing: {
    title:
      "Are you sure you want to delete this {listingStatus, plural, =1 {draft} =3 {offline} =5 {expire} other {}} listing permanently?",
    description:
      "You will not be able to undo this action if you choose to continue.",
    confirm: "Yes, delete",
    cancel: "Cancel",
  },
  duplicateListing: {
    title: "Are you sure you want to copy this listing?",
    description:
      "The copy will show in your draft listings where you can edit the content before publishing.",
    confirm: "Yes, create copy",
    cancel: "Cancel",
  },
  unsavedChanges: {
    title: "Are you sure you want to exit?",
    message: "If you exit, the details you have entered will not be saved.",
    button: {
      cancel: "Cancel",
      ok: "Exit",
    },
  },
  pagination: {
    listings: {
      summary: "Showing {startNumber}-{endNumber} of {total}",
    },
    allocatedUser: {
      summary: "Viewing {startNumber}-{endNumber} of {total} users",
    },
    quality: {
      summary: "Viewing {startNumber}-{endNumber} of {total} transactions",
    },
    allocationUsers: {
      summary: "Viewing {startNumber}-{endNumber} of {total} branches",
    },
    leadList: {
      summary: "Viewing {startNumber}-{endNumber} of {total} leads",
    },
    email: {
      summary: "Viewing {startNumber}-{endNumber} of {total} emails",
    },
    word: {
      summary: "Viewing {startNumber}-{endNumber} of {total} words",
    },
    ip: {
      summary: "Viewing {startNumber}-{endNumber} of {total} IPs",
    },
    announcements: {
      summary: "Showing {startNumber}-{endNumber} of {total}",
    },
    areaCondoSpecialist: {
      summary: "Showing {startNumber}-{endNumber} of {total}",
    },
    creditUsage: {
      summary: "Showing {startNumber}-{endNumber} of {total}",
    },
    specialistReport: {
      summary: "Showing {startNumber}-{endNumber} of {total}",
    },
    paymentHistory: {
      summary: "Showing {startNumber}-{endNumber} of {total}",
    },
    dynamicPricing: {
      summary: "Showing {startNumber}-{endNumber} of {total}",
    },
  },
  lsot: {
    placeholder:
      "Search by property/project name, street, township, city/area, state",
    placeholderMobile: "Search property, township, city, state",
  },
};
